export default "./dist/stdassets/images/icons/control-stop.png";